import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import classnames from 'classnames';
import CheckSvg from '@src/svgs/fr-check.svg';
import { SubscriptionPlanProps } from './props';
import './styles.scss';

export const SubscriptionPlan: FC<SubscriptionPlanProps> = ({
  onClick,
  isSelected,
  currency,
  features,
  period,
  price,
  subTitle,
  title,
  isDisabled,
}) => {
  return (
    <div
      className={classnames(
        'subscription-plan-card',
        isSelected && 'subscription-plan-card--active',
        isDisabled && 'subscription-plan-card--disabled',
      )}
      onClick={() => onClick?.()}
    >
      <div className="subscription-plan-card__header">
        <Svg className="subscription-plan-card__check-icon" src={CheckSvg} />
        <div className="subscription-plan-card__title">
          <h4>{title}</h4>
          <p>{subTitle}</p>
        </div>
      </div>
      <div className="subscription-plan-card__price">
        <h5>{currency}</h5>
        <h1>{price}</h1>
        <p>{period.toLowerCase()}</p>
      </div>
      <div className="subscription-plan-card__features">
        {features.map((feature, index) => (
          <div className="subscription-plan-card__feature" key={index}>
            <Svg className="subscription-plan-card__feature-icon" src={CheckSvg} />

            <span>{feature}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
